import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArcStack, ArcText, ArcToolbar } from '@src/core/ui';
import { routesConfig } from '@src/core/routes';
import { useTermsQuery } from '@src/features/auth/redux/api';

const PrivacyPage: React.FC = () => {
  const navigate = useNavigate();
  const scrollRef = useRef<HTMLDivElement>(null);
  const { data: terms, isLoading } = useTermsQuery();

  useEffect(() => {
    scrollRef.current?.scrollTo(0, 0);
  }, []);

  return (
    <ArcStack spacing={4} height="100%" p={5} px={8}>
      <ArcToolbar
        title="Privacy policy"
        titleFontSize={24}
        goBack={() => navigate(routesConfig.profile)}
      />
      <ArcStack ref={scrollRef} sx={{ overflowY: 'auto', flex: 1, bgcolor: 'background.paper', p: 4, px: 4 }}>
        {isLoading ? (
          <ArcText>Loading...</ArcText>
        ) : (
          <ArcText component="div" color="white" fontSize={16} fontWeight={400} sx={{ whiteSpace: 'pre-wrap' }}>
            {terms?.privacyPolicy ?? ''}
          </ArcText>
        )}
      </ArcStack>
    </ArcStack>
  );
};

export default PrivacyPage;
